import Billing from './containers/Billing';

export const billingRoutes = {
    path: '/billing(/:username)(/:product)',
    component: Billing
}


// WEBPACK FOOTER //
// ./src/billing/routes.js